// Base64 data-URL downloads (invoice / awb / qr / label endpoints all return
// one in `data`). Build a transient <a> and click it.
export function downloadDataUrl(dataUrl: string, filename: string) {
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
}
